module.exports = __webpack_public_path__ + "img/changement-de-vitesse.ac0fd372.png";